// Import React and Hooks
import React, { useRef, useEffect } from 'react'
// Import Utilities
import { parallaxAnimation } from '../../utilities/parallax'



// Float Img Props
interface floatImgProps {
  additionalClass:string,
  src:string,
  alt?:string,
  speed?:number,
  revert?:boolean
}

const FloatImg = ( { additionalClass, src, alt, speed, revert }:floatImgProps ) => {



  // Use Ref
  const floatImg = useRef(null)



  // Use Effect
  useEffect( () => parallaxAnimation( [floatImg] ), [])



  return (
    <picture className={`floatImg ${ additionalClass ? additionalClass : ''}`}>
      <img
        src={ src }
        alt={ alt }
        title={ alt }
        ref={ floatImg }
        data-speed={ speed }
        data-revert={ revert }
        className="floatImg__img" />
    </picture>
  )
}



export default FloatImg
